import { isArray } from '@cutwise/utils';

import GradeDictEntry from '@/customGrading/entity/GradeDictEntry';
import ColorMetric from '@/metric/entity/ColorMetric';
import DeadZoneMetric from '@/metric/entity/DeadZoneMetric';
import PavillionColorViboxMetric from '@/metric/entity/PavillionColorViboxMetric';

export type GradeSource = Nullable<ColorMetric | DeadZoneMetric | PavillionColorViboxMetric>;

export class InitialGradeSource {
  grade!: GradeDictEntry;
  endGrade?: GradeDictEntry;
  source: GradeSource;

  constructor(grade: GradeDictEntry | [GradeDictEntry, Nullable<GradeDictEntry>], source: GradeSource = null) {
    if (grade instanceof GradeDictEntry) {
      this.grade = grade;
    } else if (isArray(grade)) {
      const [startGrade, endGrade] = grade;

      this.grade = startGrade;

      if (endGrade instanceof GradeDictEntry) {
        this.endGrade = endGrade;
      }
    }

    this.source = source;
  }

  get id() {
    return this.grade.id;
  }

  get title() {
    let result = this.grade.title;

    if (this.isRange) {
      result += `-${this.endGrade!.title}`;
    }

    return result;
  }

  get isRange() {
    return this.grade && this.endGrade;
  }
}
